// extracted by mini-css-extract-plugin
module.exports = {"board_outline":"Board_board_outline__-bMyv","board_body":"Board_board_body__Rnbwn","board_hidden":"Board_board_hidden__2--IJ"};